import httpFactory from '@adjust/dashboard-core/api/instance/http-factory';

const http = httpFactory({ baseURL: configurationURL.accounts.baseUrl });

export const getTwoFactorConfiguration = () => http.get(`/two_factor_auth_configuration`).then(resp => resp.data);

export const updateTwoFactorConfiguration = (enable: boolean) =>
  http.patch(`/two_factor_auth_configuration`, { enable }).then(response => response.data);
